import { memo } from 'react';
import { ButtonProps } from '@chakra-ui/react';

import {
  StepExtraButton,
  StepExtraButtonPosition,
  StepFooterComponent,
  StepFooterProps,
} from '~/core/shared/types';
import { usePerformTransitionAndNavigate } from '../hooks/usePerformTransitionAndNavigate';
import { FooterNavigationButtons } from './FooterNavigationButtons.component';

const buildLeftButtonProps = (
  button: StepExtraButton | undefined,
  position: StepExtraButtonPosition,
  onClick: () => Promise<void>,
): ButtonProps | undefined => {
  if (button === undefined) return undefined;

  return {
    children: button.text,
    onClick,
    type: 'button',
  };
};

const DefaultStepFooterComponent = ({
  step,
  isProcessing,
}: StepFooterProps) => {
  const leftButton = step.extraButtons
    ?.filter((f) => f.position === 'left')
    .at(0);
  const performTransition = usePerformTransitionAndNavigate(
    leftButton?.transition,
  );

  if (step.options?.hideContinueButton) {
    return null;
  }

  return (
    <FooterNavigationButtons
      leftButtonProps={buildLeftButtonProps(
        leftButton,
        'left',
        performTransition,
      )}
      rightButtonProps={{
        children: step.proceedButtonText || 'Continue',
        disabled: isProcessing,
        loading: isProcessing,
        loadingText: 'Processing...',
        ml: 'auto',
        type: 'submit',
      }}
    />
  );
};

export const DefaultStepFooter: StepFooterComponent = memo(
  DefaultStepFooterComponent,
);
